import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardMedia, Typography, Button, Box } from '@mui/material';
import TypeSelectorDialog from './TypeSelectorDialog';

const ProductCard = ({
                         product,
                         onAddToCart,
                         buttonColor,
                         buttonTextColor,
                         priceColor,
                         showPrice,
                         // ⬇️ QO‘SHILDI
                         showCount,
                         quantityField, // 'remain' yoki 'remainBusiness'
                     }) => {
    const [quantity, setQuantity] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const { t } = useTranslation();

    const handleAdd = () => {
        if (product.types.length > 0) {
            setOpenDialog(true);
        } else {
            setQuantity(1);
            onAddToCart(product, 1);
        }
    };

    const handleIncrement = () => {
        const newQty = quantity + 1;
        setQuantity(newQty);
        onAddToCart(product, newQty);
    };

    const handleDecrement = () => {
        const newQty = quantity > 0 ? quantity - 1 : 0;
        setQuantity(newQty);
        onAddToCart(product, newQty);
    };

    // ⬇️ QO‘SHILDI: ko‘rsatiladigan miqdor qiymati
    const displayQty = product?.[quantityField];

    return (
        <Card
            sx={{
                width: '100%',
                height: '100%',
                minHeight: 220,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                borderRadius: 2,
                boxShadow: 2,
                boxSizing: 'border-box',
                m: 0.5,
            }}
        >
            <CardMedia
                component="img"
                image={product.photoUrl || '/no-image.png'}
                alt={product.name}
                sx={{ objectFit: 'contain', backgroundColor: '#f5f5f5', width: '100%', height: 120 }}
            />

            <CardContent
                sx={{
                    flexGrow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    p: 0.5,
                    m: 0.2,
                    '&:last-child': { pb: 0.5 },
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        overflow: 'hidden',
                        display: '-webkit-box',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 2,
                        lineHeight: 1.2,
                        mb: 0.5,
                    }}
                >
                    {product.name}
                </Typography>

                {/* ⬇️ QO‘SHILDI: offCount=true bo‘lsa miqdorni ko‘rsatamiz */}
                {showCount && (
                    <Typography variant="caption" sx={{ mb: 0.5, color: 'text.secondary' }}>
                        Miqdori: {Number(displayQty ?? 0).toLocaleString()}
                    </Typography>
                )}

                {/* Narx: showPrice true bo‘lsa chiqadi */}
                {showPrice && (
                    <Typography
                        variant="caption"
                        sx={{ mb: 0.5, color: priceColor || 'text.secondary', fontWeight: 600 }}
                    >
                        {product.price.toLocaleString()} {t('currency')}
                    </Typography>
                )}

                <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'center' }}>
                    {quantity === 0 ? (
                        <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={handleAdd}
                            sx={{
                                textTransform: 'none',
                                py: 0.5,
                                fontSize: '0.75rem',
                                backgroundColor: buttonColor || 'primary.main',
                                color: buttonTextColor || '#fff',
                                '&:hover': { backgroundColor: buttonColor || 'primary.dark', opacity: 0.9 },
                            }}
                        >
                            {t('addToCart')}
                        </Button>
                    ) : (
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            sx={{
                                borderRadius: 1,
                                overflow: 'hidden',
                                width: '100%',
                                height: 36,
                                border: `1px solid ${buttonColor || '#ccc'}`,
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={handleDecrement}
                                sx={{
                                    minWidth: 40,
                                    height: '100%',
                                    borderRadius: 0,
                                    fontWeight: 'bold',
                                    backgroundColor: buttonColor || 'primary.main',
                                    color: buttonTextColor || '#fff',
                                    '&:hover': { backgroundColor: buttonColor || 'primary.dark', opacity: 0.9 },
                                }}
                            >
                                –
                            </Button>

                            <Box
                                component="input"
                                type="number"
                                value={quantity}
                                onChange={(e) => {
                                    const val = Math.max(0, parseInt(e.target.value || '0', 10));
                                    setQuantity(val);
                                    onAddToCart(product, val);
                                }}
                                sx={{ width: '100%', textAlign: 'center', border: 'none', outline: 'none', fontSize: '1rem' }}
                            />

                            <Button
                                variant="contained"
                                onClick={handleIncrement}
                                sx={{
                                    minWidth: 40,
                                    height: '100%',
                                    borderRadius: 0,
                                    fontWeight: 'bold',
                                    backgroundColor: buttonColor || 'primary.main',
                                    color: buttonTextColor || '#fff',
                                    '&:hover': { backgroundColor: buttonColor || 'primary.dark', opacity: 0.9 },
                                }}
                            >
                                +
                            </Button>
                        </Box>
                    )}
                </Box>
            </CardContent>

            {/* TYPE tanlash dialogi */}
            <TypeSelectorDialog
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                types={product.types}
                parentProduct={product}
                onAddToCart={onAddToCart}
                // ⬇️ QO‘SHILDI
                showCount={showCount}
                quantityField={quantityField}
            />
        </Card>
    );
};

export default ProductCard;
